import { Injectable } from '@angular/core';
import { Route, Router } from '@angular/router';
import { NomWebServicesJson } from '@common/services/nom-web-services-json';
import { VisualStateService } from '@common/services/visual-state-service';
import { AppService } from '@suite/app.service';

import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class RouteGuard {
    constructor(
        private appService: AppService,
        private router: Router,
        private authService: AuthService,
        public nomWebServicesJson: NomWebServicesJson,
        public visualStateService: VisualStateService
    ) {}

    async canLoad(route: Route): Promise<boolean> {
        const { path } = route;
        if (this.getTokenFromPath(path)) {
            this.visualStateService.isDesktop = true;
            return true;
        }

        if (this.getDesktopMode()) {
            this.visualStateService.isDesktop = true;
        }
        const providerName = localStorage.getItem('providerName') ? localStorage.getItem('providerName') : '';
        const idToken = localStorage.getItem('idToken') ? localStorage.getItem('idToken') : '';
        const sessionDataStatus = await this.appService.loadSessionData();
        if (sessionDataStatus) {
            return true;
        } else if (providerName === 'OKTA' && idToken) {
            await this.authService.loginWithToken(providerName);
        } else if (this.authService.isTokenValid(idToken)) {
            await this.authService.loginWithToken(providerName);
        } else if (localStorage.getItem('accessToken')) {
            await this.authService.loginWithToken(providerName);
        } else {
            this.nomWebServicesJson.clearSessionData();
            this.router.navigate(['/login'], { queryParamsHandling: 'preserve' } /* path.slice(path.indexOf('?')) */ /* path.slice(path.indexOf('?')) */);
            return false;
        }
    }

    private getDesktopMode(): boolean {
        return !!localStorage.getItem('DesktopMode');
    }

    private getTokenFromPath(path: string): string {
        let token = null;
        if (path) {
            const queryParamsIndex: number = path.indexOf('?');
            if (queryParamsIndex > -1) {
                const queryParamsStr: string = path.substring(queryParamsIndex + 1);
                if (queryParamsStr) {
                    const queryParamsArray: Array<string> = queryParamsStr.split('&');
                    if (queryParamsArray && queryParamsArray.length > 0) {
                        for (const param of queryParamsArray) {
                            if (param) {
                                const index = param.indexOf('=');
                                if (index > -1) {
                                    const key = param.substring(0, index);
                                    const value = param.substring(index + 1);
                                    if (key && key === 'token') {
                                        token = decodeURIComponent(value);
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return token;
    }
}
